import React, { useContext, useEffect, useMemo, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';
import axios from '../../../../api/axios';
import { AuthContext } from '../../../../auth';
import { ActionIcon, Box, Flex } from '@mantine/core';
import { BsPrinter } from 'react-icons/bs';
import ExportExcel from '../../../ExportExcel';

function TabsHistoryMeetingDark({ listHistoryMeeting, listUser }) {

    const { tokens } = useContext(AuthContext);

    const tokenUser = tokens?.token;

    const navigate = useNavigate();
    const detailMeeting = (row) => {
        navigate("/detail-meeting/" + row)
    }

    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    };

    const [listRuangan, setListRuangan] = useState([]);

    const retrieveDetailRuangan = () => {

        axios.get(`/manage/ruangan/`,
            {
                headers:
                {
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setListRuangan(res.data);

            }).catch(err => {

                console.error(err)
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data pada server!',
                })
            })
    };

    useEffect(() => {

        if (tokenUser !== undefined) retrieveDetailRuangan()

    }, [tokenUser]);

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = listHistoryMeeting.map(({ ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                const user = listUser.find((user) => user.id === data.user);
                const userName = user ? user.first_name + ' ' + user.last_name : '';
                const room = listRuangan.find((ruangan) => ruangan.id === data.ruangan);
                const roomName = room ? room.nama_ruangan : '';

                return {
                    ...data,
                    user_name: userName,
                    statusRaw: data.status,
                    meetingTypeRaw: data.online === true ? 'Online' : 'Offline',
                    namaMeeting: truncateText(data.nama_meeting || '', 25),
                    roomName: roomName,

                };
            })
        );
    }, [listHistoryMeeting, listUser, listRuangan]);

    const columns = useMemo(
        () => [
            {
                header: 'Info',
                accessorFn: row => (
                    <div >
                        <Button variant='btn' onClick={() => detailMeeting(row.id)}>
                            &nbsp;<FaInfoCircle size={20} color='#D2DC02' />&nbsp;
                        </Button>
                    </div>
                ),
                size: 50,
                mantineTableHeadCellProps: {
                    align: 'left',
                },
                mantineTableBodyCellProps: {
                    align: 'left',
                },
            },
            {
                header: 'Permintaan dari',
                accessorKey: 'user_name',
                mantineTableHeadCellProps: {
                    align: 'center',
                },
                mantineTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Nama Meeting',
                accessorKey: 'namaMeeting',
                mantineTableHeadCellProps: {
                    align: 'center',
                },
                mantineTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Tanggal',
                accessorFn: (row) => new Date(row.waktu_mulai),
                id: 'tanggal',
                filterVariant: 'date-range',
                Cell: ({ cell }) => {
                    const date = cell.getValue();
                    const day = String(date.getUTCDate()).padStart(2, '0');
                    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                    const year = date.getUTCFullYear();
                    return `${day}/${month}/${year}`;
                },
                mantineTableHeadCellProps: {
                    align: 'center',
                },
                mantineTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Nama Ruangan',
                accessorKey: 'roomName',
                mantineTableHeadCellProps: {
                    align: 'center',
                },
                mantineTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Tipe Meeting',
                accessorKey: 'meetingTypeRaw',
                Cell: ({ cell }) => (
                    <div style={{ marginBottom: '0px', marginTop: '0px' }}>
                        {(() => {
                            switch (cell.getValue()) {
                                case 'Online':
                                    return <span style={{ color: '#D2DC02' }}>Online</span>;
                                case 'Offline':
                                    return <span >Offline</span>;
                                default:
                                    return null;
                            }
                        })()}
                    </div>
                ),
                mantineTableHeadCellProps: {
                    align: 'center',
                },
                mantineTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Status',
                accessorKey: 'statusRaw',
                Cell: ({ cell }) => (
                    <div style={{ marginBottom: '0px', marginTop: '0px' }}>
                        {(() => {
                            switch (cell.getValue()) {
                                case 'approved':
                                    return <span style={{ color: '#84C38A' }}>Disetujui</span>;
                                case 'denied':
                                    return <span style={{ color: '#FF0060' }}>Ditolak</span>;
                                default:
                                    return null;
                            }
                        })()}
                    </div>
                ),
                mantineTableHeadCellProps: {
                    align: 'center',
                },
                mantineTableBodyCellProps: {
                    align: 'center',
                },
            },
        ],
        [],
    );

    const handleExportRowsExcelData = () => {
        const rows = tableHistoryMeeting.getRowModel().rows;

        const excelData = rows.map((row) => {
            const { original } = row;
            return {
                'Tanggal': new Date(original.waktu_mulai).toLocaleDateString('id-ID'),
                'Nama Meeting': original.nama_meeting,
                'Permintaan Dari': original.user_name,
                'Nama Ruangan': original.roomName,
                'Tipe Meeting': original.online ? 'Online' : 'Offline',
                'Status': original.status === 'approved' ? 'Disetujui' : original.status === 'denied' ? 'Ditolak' : '',
            };
        });

        return excelData;
    };

    const tableHistoryMeeting = useMantineReactTable({
        columns,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        initialState: {
            density: 'xs',
            sorting: [
                {
                    id: 'tanggal',
                    desc: true,
                },
            ],
        },
        data: dataTable,
        enableRowNumbers: true,
        rowNumberMode: 'static',
        isMultiSortEvent: () => true,
        mantineTableProps: { highlightOnHover: false },
        renderTopToolbarCustomActions: () => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    variant='btn'
                >
                    <ExportExcel
                        getExcelData={() => handleExportRowsExcelData()}
                        fileName={`Report Riwayat Meeting`}
                    />
                </Button>
            </Box>
        ),
    });

    return (
        <>
            <MantineReactTable
                table={tableHistoryMeeting}
            />
        </>
    )
}

export default TabsHistoryMeetingDark
